function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M174-280q-12.75 0-21.37-8.63Q144-297.25 144-310v-90H80v-160h64v-90q0-12.75 8.63-21.38Q161.25-680 174-680h676q12.75 0 21.38 8.62Q880-662.75 880-650v340q0 12.75-8.62 21.37Q862.75-280 850-280H174Zm30-60h308v-280H204v280Z"
});

var SvgWebappIconBattery050LightTheme = function SvgWebappIconBattery050LightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#000000",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconBattery050LightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-battery-050-light-theme.3df66360.svg";
export { ForwardRef as ReactComponent };